// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Right-to-left overrides for Arabic.
 * Ant Design components are mirrored by ConfigProvider direction="rtl";
 * these rules cover the hand-written panel layout (sidebar, header, tables)
 * that still uses physical left/right properties.
 */
[dir="rtl"] {
  text-align: right;
}

[dir="rtl"] .sidebar,
[dir="rtl"] .sidersidenav,
[dir="rtl"] .ant-layout-sider {
  left: auto !important;
  right: 0 !important;
}

[dir="rtl"] .page-wrapper {
  margin-left: 0;
  margin-right: 230px;
}

[dir="rtl"] .mini-sidebar .page-wrapper {
  margin-left: 0;
  margin-right: 78px;
}

[dir="rtl"] .header .header-left {
  float: right;
}

[dir="rtl"] .header .header-right,
[dir="rtl"] .header .nav.user-menu {
  float: left;
}

[dir="rtl"] .float-left {
  float: right !important;
}

[dir="rtl"] .float-right {
  float: left !important;
}

[dir="rtl"] .text-left {
  text-align: right !important;
}

[dir="rtl"] .text-right {
  text-align: left !important;
}

[dir="rtl"] .me-1,
[dir="rtl"] .me-2,
[dir="rtl"] .me-3 {
  margin-right: 0 !important;
}

[dir="rtl"] .me-1 {
  margin-left: 0.25rem !important;
}

[dir="rtl"] .me-2 {
  margin-left: 0.5rem !important;
}

[dir="rtl"] .me-3 {
  margin-left: 1rem !important;
}

[dir="rtl"] .ms-1,
[dir="rtl"] .ms-2,
[dir="rtl"] .ms-3 {
  margin-left: 0 !important;
}

[dir="rtl"] .ms-1 {
  margin-right: 0.25rem !important;
}

[dir="rtl"] .ms-2 {
  margin-right: 0.5rem !important;
}

[dir="rtl"] .ms-3 {
  margin-right: 1rem !important;
}

/* Keep numbers, dates, money and e-mail addresses left-to-right inside RTL text */
[dir="rtl"] .ltr-text,
[dir="rtl"] input[type="email"],
[dir="rtl"] input[type="url"],
[dir="rtl"] input[type="tel"],
[dir="rtl"] input[type="number"] {
  direction: ltr;
  text-align: right;
}

[dir="rtl"] .language-dropdown-container .language-selector {
  flex-direction: row-reverse;
}
`, "",{"version":3,"sources":["webpack://./src/rtl.css"],"names":[],"mappings":"AAAA;;;;;EAKE;AACF;EACE,iBAAiB;AACnB;;AAEA;;;EAGE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;;EAGE,0BAA0B;AAC5B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,kFAAkF;AAClF;;;;;EAKE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;AAC7B","sourcesContent":["/*\n * Right-to-left overrides for Arabic.\n * Ant Design components are mirrored by ConfigProvider direction=\"rtl\";\n * these rules cover the hand-written panel layout (sidebar, header, tables)\n * that still uses physical left/right properties.\n */\n[dir=\"rtl\"] {\n  text-align: right;\n}\n\n[dir=\"rtl\"] .sidebar,\n[dir=\"rtl\"] .sidersidenav,\n[dir=\"rtl\"] .ant-layout-sider {\n  left: auto !important;\n  right: 0 !important;\n}\n\n[dir=\"rtl\"] .page-wrapper {\n  margin-left: 0;\n  margin-right: 230px;\n}\n\n[dir=\"rtl\"] .mini-sidebar .page-wrapper {\n  margin-left: 0;\n  margin-right: 78px;\n}\n\n[dir=\"rtl\"] .header .header-left {\n  float: right;\n}\n\n[dir=\"rtl\"] .header .header-right,\n[dir=\"rtl\"] .header .nav.user-menu {\n  float: left;\n}\n\n[dir=\"rtl\"] .float-left {\n  float: right !important;\n}\n\n[dir=\"rtl\"] .float-right {\n  float: left !important;\n}\n\n[dir=\"rtl\"] .text-left {\n  text-align: right !important;\n}\n\n[dir=\"rtl\"] .text-right {\n  text-align: left !important;\n}\n\n[dir=\"rtl\"] .me-1,\n[dir=\"rtl\"] .me-2,\n[dir=\"rtl\"] .me-3 {\n  margin-right: 0 !important;\n}\n\n[dir=\"rtl\"] .me-1 {\n  margin-left: 0.25rem !important;\n}\n\n[dir=\"rtl\"] .me-2 {\n  margin-left: 0.5rem !important;\n}\n\n[dir=\"rtl\"] .me-3 {\n  margin-left: 1rem !important;\n}\n\n[dir=\"rtl\"] .ms-1,\n[dir=\"rtl\"] .ms-2,\n[dir=\"rtl\"] .ms-3 {\n  margin-left: 0 !important;\n}\n\n[dir=\"rtl\"] .ms-1 {\n  margin-right: 0.25rem !important;\n}\n\n[dir=\"rtl\"] .ms-2 {\n  margin-right: 0.5rem !important;\n}\n\n[dir=\"rtl\"] .ms-3 {\n  margin-right: 1rem !important;\n}\n\n/* Keep numbers, dates, money and e-mail addresses left-to-right inside RTL text */\n[dir=\"rtl\"] .ltr-text,\n[dir=\"rtl\"] input[type=\"email\"],\n[dir=\"rtl\"] input[type=\"url\"],\n[dir=\"rtl\"] input[type=\"tel\"],\n[dir=\"rtl\"] input[type=\"number\"] {\n  direction: ltr;\n  text-align: right;\n}\n\n[dir=\"rtl\"] .language-dropdown-container .language-selector {\n  flex-direction: row-reverse;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
